exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_readable-stream@2.3.6@readable-stream/readable-browser.js
// module id = ./node_modules/_readable-stream@2.3.6@readable-stream/readable-browser.js
// module chunks = 0 1 2